module.exports = __webpack_public_path__ + "media/assets/faria_products/AN-AR-a1443622f53578898c93994d9c0e63889c006ea5814cae8fad7127c2c9552432.png";